// Atalho da página da VM para Gestão → Eventos (últimas 24 h). Só administradores.
import React from 'react';
import { Link } from 'react-router-dom';

export default function VmEventsLink({ vmid, isAdmin }) {
  if (!isAdmin) return null;
  const to = new Date();
  const from = new Date(to.getTime() - 24 * 3600 * 1000);
  const href = `/eventos?target=vm:${encodeURIComponent(vmid)}&from=${from.toISOString()}&to=${to.toISOString()}`;
  return <Link to={href} className="vm-events-link">📈 Ver eventos</Link>;
}
